export enum TaxonomyTab {
  unmapped = 'unmapped',
  underProcessing = 'underProcessing',
  mapped = 'mapped'
}
